import { render, staticRenderFns } from "./ScreenInsercaoDeDiuGuiadoPorTransvaginal.vue?vue&type=template&id=0ecf0cb2&scoped=true&"
import script from "./ScreenInsercaoDeDiuGuiadoPorTransvaginal.vue?vue&type=script&lang=js&"
export * from "./ScreenInsercaoDeDiuGuiadoPorTransvaginal.vue?vue&type=script&lang=js&"
import style0 from "./ScreenInsercaoDeDiuGuiadoPorTransvaginal.vue?vue&type=style&index=0&id=0ecf0cb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecf0cb2",
  null
  
)

export default component.exports